import { createRouter, createWebHashHistory } from 'vue-router'
import { setDocumentTitle } from '@/i18n/index'
import { mobileCheck } from '@/lib/utils.js'

// 路由配置
const routes = [
  {
    path: '/',
    redirect: '/download',
  },
  {
    path: '/productinfo',
    redirect: '/download',
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/views/download/DownloadPage.vue'),
    meta: {
      titleKey: 'hf_web_download_app_msg',
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () =>
      mobileCheck.isMobile
        ? import('@/views/register/RegisterPage.vue')
        : import('@/views/register/RegisterWeb.vue'),
    meta: {
      titleKey: 'hf_web_register_name',
    },
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/agreement/AgreementCollection.vue'),
  },
  {
    path: '/deleteAccount',
    name: 'DeleteAccount',
    component: () => import('@/views/deleteAccount/deleteAccountPage.vue'),
  },
]

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  setDocumentTitle(to.meta.titleKey || '').then(() => next())
})

export default router
